export default __webpack_public_path__ + "i18n/nl.dc82731ad2e56413b590295ff2e4436e.json";